// console.log(`js/01-pageSections/callout.js is working`);

const callouts = document.querySelectorAll(`.callout`);

if (callouts) {
  const calloutInnerpage = document.querySelector(`.page .callout`);
  const calloutHomepage = document.querySelector(`.home .callout`);

  callouts.forEach((callout) => {
    let windowHeight;
    const calloutContent = callout.querySelector(`.callout-content`);
    const calloutImage = callout.querySelector(`.callout-image`);

    function init() {
      windowHeight = window.innerHeight;
    }

    function checkPosition() {
      let positionFromTop = callout.getBoundingClientRect().top;
      if (positionFromTop - windowHeight <= -250) {
        calloutContent.classList.remove(`hide-block`);
        calloutImage.classList.remove(`hide-block`);
      }
    }

    if (calloutInnerpage || calloutHomepage) {
      window.addEventListener(`scroll`, checkPosition);
      window.addEventListener(`resize`, init);

      init();
    }
  });
}
